// Sentry first so it captures the earliest possible errors.
import './sentry';

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

// Echo + pusher-js are ~100KB that only the chat pages use — load on demand.
// echo.js dispatches 'echo-ready' when window.Echo exists; the messages view
// waits for it. wire:navigate hook covers SPA navigations into the chat.
const needsEcho = () => window.location.pathname.startsWith('/account/messages');
const loadEcho = () => {
    if (window.Echo || window.__echoLoading) return;
    window.__echoLoading = import('./echo').then(() => window.dispatchEvent(new CustomEvent('echo-ready')));
};
if (needsEcho()) loadEcho();
document.addEventListener('livewire:navigated', () => { if (needsEcho()) loadEcho(); });
